<template>
  <div class="AccountCodeSelect"
       v-if="accountCode">
    <popHeader @cancel="cancel"
               :title="$t('accountCode_Title')"></popHeader>
    <div class="mint-searchbar">
      <div class="mint-searchbar-inner">
        <i class="mintui mintui-search"></i>
        <input type="search"
               :placeholder="$t('accountCode_SearchPlaceHold')"
               class="mint-searchbar-core"
               v-model="value"
               @input='ksearch'>
      </div>
      <a class="mint-searchbar-cancel"
         v-if="value"
         @click="value='';inputSearch();">{{$t('cancel')}}
      </a>
    </div>

    <ul class="content" v-if='onlyPay'>
      <li class="option act">{{$t('accountCode_pay')}}
      </li>
    </ul>

    <ul class="content" v-else>
      <li class="option"
          @click="settype(1)"
          :class="{act:type==1}">{{$t('accountCode_common')}}
      </li>
      <li class="option"
          @click="settype(2)"
          :class="{act:type==2}">{{$t('accountCode_fee')}}
      </li>
      <li class="option"
          @click="settype(3)"
          :class="{act:type==3}">{{$t('accountCode_pay')}}
      </li>
      <li class="option"
          @click="settype(4)"
          v-if='isJingJiang'
          :class="{act:type==4}">{{$t('accountCode_preAuth')}}
      </li>
      <li class="option"
          @click="settype(0)"
          :class="{act:type==0}">{{$t('accountCode_list')}}
      </li>
    </ul>

    <div v-if="type == 0"
         class="vscoll">
      <a class="mint-cell"
         v-for="(item, index) in search"
         :key="'search' + index">
        <div class="mint-cell-wrapper"
             @click="select(item)">
          <div class="mint-cell-title">
            <span class="mint-cell-text">
            {{item.code}}
            </span>
          </div>
          <div class="mint-cell-value ">
            <span>{{item.descript}}</span>
          </div>
        </div>
      </a>
    </div>
    <div v-else-if="type == 1"
         class="vscoll">
      <a class="mint-cell"
         v-for="(item, index) in hsSearch"
         v-if='item.catPosting != "TA" || onlyPay'
         :key="'hsSearch' + index">
        <div class="mint-cell-wrapper"
             @click="select(item)">
          <div class="mint-cell-title">
            <span class="mint-cell-text">
            {{item.code}}
            </span>
          </div>
          <div class="mint-cell-value ">
            <span>{{item.descript}}</span>
          </div>
        </div>
      </a>
    </div>
    <div v-else
         class="vscoll">
      <template v-for="(item, index) in  (type == 2?accountCode.charge: (type == 3 ? accountCode.pay : accountCode.preAuthorization))">
        <a class="mint-cell"
           :key="'accountCode-a' + index">
          <div class="mint-cell-wrapper">
            <div class="mint-cell-title">
              <span class="mint-cell-text">
                <i class="iconfont icon-jiahao"
                   v-if="!item.expand"
                   @click="setExpand2(item,$event)"></i>
                <i class="iconfont icon-iconless"
                   v-else
                   @click="setExpand2(item,$event)"></i>
                {{item.descript}}
              </span>
            </div>
          </div>
        </a>
        <div v-show="item.expand"
             :key="'accountCode-div' + index">
          <!--这里挂AR账，在入账的时候不要显示，只在结账退房的时候显示-->
          <a class="mint-cell index2"
             v-for="(sub, index2) in item.list"
             v-if='sub.catPosting != "TA" || onlyPay'
             :key="'subList' + index2">
            <div class="mint-cell-wrapper"
                 @click="select(sub)">
              <div class="mint-cell-title">
                <span class="mint-cell-text">
                  {{sub.code}} -- {{sub.descript}}
                </span>
              </div>
            </div>
          </a>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  import popHeader from "../../../common/popHeader"
  import {
    Toast,
    MessageBox
  } from "mint-ui";

  export default {
    data() {
      return {
        hsSearch: localStorage.accounCodeSearch ?
          JSON.parse(localStorage.accounCodeSearch) :
          [],
        accountCode: null,
        value: '',
        type: 1,
        search: [],
        onlyPay: false,
        isJingJiang: localStorage.getItem('isJingJiang') == 'yes',
      };
    },
    props: {},
    mounted() {
      if (this.hsSearch.length > 0) {
        this.type = 1;
      } else {
        this.type = 2;
      }
    },
    methods: {
      show(onlyPay) {
        if (this.accountCode == null) {
          this.showPage();
        } else {
          this.disTaCode = true;
        }
        if (onlyPay){
          this.onlyPay = true
          this.type = 3;
          this.settype(3)
        } else {
          this.onlyPay = false
        }
      },
      settype(t) {
        this.type = t;
        if (t == 0) {
          this.inputSearch();
        }
      },
      ksearch() {
        this.type = 0;
        this.inputSearch();
      },
      inputSearch() {
        this.search = [];
        this.searchDo(this.accountCode.charge);
        this.searchDo(this.accountCode.pay);
        this.searchDo(this.accountCode.preAuthorization);
      },
      searchDo(v) {
        for (var i = 0; i < v.length; i++) {
          var sub = v[i].list;
          for (var n = 0; n < sub.length; n++) {
            if (this.value == "" || sub[n].code.indexOf(this.value) >= 0 || sub[n].descript.indexOf(this.value) >= 0) {
              this.search.push(sub[n]);
            }
          }
        }
      },
      select(item) {
        this.finditem(item);
        if (this.hsSearch.length >= 15) {
          this.hsSearch.shift();
        }
        this.hsSearch.splice(0, 0, item);
        localStorage.setItem("accounCodeSearch", JSON.stringify(this.hsSearch));
        this.$emit("select", item);
      },
      finditem(item) {
        for (var i = 0; i < this.hsSearch.length; i++) {
          if (this.hsSearch[i].code == item.code) {
            this.hsSearch.splice(i, 1,);
            return true;
          }
        }
        return false;
      },
      cancel() {
        this.$emit("cancel");
      },

      setExpand2(item, e) {
        e.stopPropagation();
        this.$set(item, "expand", !item.expand);
      },
      showPage() {
        this.$http
          .post("/mobilepmsapi/reception/getAccountCodeByPos", {})
          .then(res => {
            if (res.data.result == 0) {
              let temp = res.data.retVal || {}
              if(temp.preAuthorization && temp.preAuthorization.length > 0){
                temp.preAuthorization.map((item) => {
                  if(item.list && item.list.length > 0){
                    item.list.map((item2) => {
                      item2.isPreAuth = true
                    })
                  }
                })
              }

              this.accountCode = res.data.retVal;
              this.disTaCode = true;
            } else {
              this.msg(res.data.msg);
            }
          });
      },
      msg(msg) {
        Toast({
          message: msg,
          position: "bottom",
          duration: 3000
        });
      }
    },
    components: {
      popHeader
    }
  };
</script>

<style lang="less">
  .AccountCodeSelect {
    width: 100%;

    .index1 {
      padding-left: 1rem;
    }

    .index2 {
      padding-left: 1rem;
    }

    .mint-cell {
      min-height: 37px;

      .mint-cell-wrapper {
        font-size: 0.34rem;
        width: 90%;
        margin: 0 auto;
      }
    }

    .vscoll {
      overflow-y: scroll;
      -webkit-overflow-scrolling: touch;
      height: ~"calc(100vh - 132px)";
      clear: both;
    }

    .mint-cell-text .iconfont {
      color: #999;
      padding: 0.3rem;
    }

    .mint-searchbar {
      background: #ffffff;
      border-radius: 5px;
    }

    .mint-searchbar-inner {
      background: #f7f8fa;
      border-radius: 1rem;
    }

    .mint-searchbar-core {
      text-indent: 0.3rem;
      background: #f7f8fa;
    }

    .mintui-search {
      font-size: 0.5rem;
      margin-left: 0.2rem;
    }

    .mint-searchbar-cancel {
      color: #000;
    }

    .content {
      background: #f7f8fa;
      width: 96%;
      margin: 0 auto;
      border-radius: 5px;
      display: flex;

      .option {
        flex: 1;
        text-align: center;
        /*float: left;*/
        height: 1rem;
        /*width: 25%;*/
        line-height: 1rem;
        color: #333333;
        font-size: 14px;

        &.act {
          border-bottom: 2px #f69c2d solid;
          color: #f69c2d
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// AccountCode.vue?d3985894